var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Inactive_icon",
    "data-name": "Inactive icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Inactive_icon-2",
    "data-name": "Inactive icon",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#e12f2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveicon);
export default __webpack_public_path__ + "static/media/Inactive icon.90808644f80cb12c32b8c2ec0b7dabba.svg";
export { ForwardRef as ReactComponent };